import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CustomFormValidator {
  static required(errorMessage: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      return control.value ? null : { required: errorMessage };
    };
  }

  static email(errorMessage: string): ValidatorFn {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return (control: AbstractControl): ValidationErrors | null => {
      return emailRegex.test(control.value) ? null : { email: errorMessage };
    };
  }

  static minLength(minLength: number, errorMessage: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      return control.value && control.value.length >= minLength
        ? null
        : { minlength: errorMessage };
    };
  }
  
  static phoneNumber(errorMessage: string): ValidatorFn {
    const phoneRegex = /^[0-9]+$/;
    return (control: AbstractControl): ValidationErrors | null => {
      return phoneRegex.test(control.value) ? null : { phoneNumber: errorMessage };
    };
  }

  static password(errorMessage: string): ValidatorFn {
    const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return (control: AbstractControl): ValidationErrors | null => {
      return passwordRegex.test(control.value) ? null : { password: errorMessage };
    };
  }
}

export function getErrorMessage(control: AbstractControl): string {
    const errors = control.errors;
    if (errors) {
      for (const key in errors) {
        if (errors.hasOwnProperty(key)) {
          return errors[key];
        }
      }
    }
    return '';
}
  
